//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The Camera barcode configuration values. */
export const CameraBarcodeConfiguration = {
    /** Off */
    Off: 0,

    /** Available */
    Available: 1,

    /** Always on */
    AlwaysOn: 2,

    /** Passive */
    Passive: 3
} as const;

/** The Camera barcode configuration values. */
export const CameraBarcodeConfigurationDescription: Record<number, string> = {
    0: "Off",

    1: "Available",

    2: "Always On",

    3: "Passive"
};

/** The Camera barcode configuration values. */
export type CameraBarcodeConfiguration = typeof CameraBarcodeConfiguration[keyof typeof CameraBarcodeConfiguration];
